import {create} from 'zustand';
import type {UseIsAutocompleteFocusedStoreProps} from './types';

const useIsAutocompleteFocusedStore = create<UseIsAutocompleteFocusedStoreProps>(set => ({
	isAutocompleteFocused: false,
	setIsAutocompleteFocused: (focused: boolean) => set({isAutocompleteFocused: focused}),
}));

export {useIsAutocompleteFocusedStore};
